/**
 * QUÉ CLIENTES SALEN EN LA PANTALLA CLIENTES Y SUS FILTROS (sacados de `AdminDashboard.jsx`
 * el 19-10, cuando el Gestor de clientes pasó a ser la pantalla Clientes).
 *
 *   - SOLO LOS ACTIVOS (Francisco, 19-10: «los clientes que no están activos no tienen que
 *     aparecer en el listado»). Se fueron las pestañas Sin entrenador / Todos los clientes y
 *     Activos / Fuera / Todos, que además contaban con criterios distintos (284 frente a
 *     319). Al de fuera se llega por Usuarios o por el Dashboard, y se reactiva en su ficha.
 *     El entrenador ve a todos los activos, como el administrador (Jesús, 13-08).
 *   - Momento: las preguntas del equipo de la reunión del 25-09.
 *   - Todo vive en la dirección (14-10, RUT-12): al volver de una ficha sale como se dejó.
 */
import { estaFuera } from './cuentaClientes';
import { hoyLocal } from './horaEspana';
import { leerFiltros } from './filtrosEnLaDireccion';

/** Lo que sale en la lista: activo y no tu propia ficha. `estaFuera` es el mismo criterio
 *  que cuenta los activos en el resto del panel (caducados, bajas y registros a medias). */
export const esDeLaLista = (c) => !!c && !c.es_tu_ficha && !estaFuera(c);

/** Los clientes que llegan a la lista: los activos y, CUANDO SE BUSCA, también los que
 *  ya no están (Francisco, 20-10). El entrenador no tiene Usuarios, y sin esto no llegaba
 *  a la ficha de un cliente suyo caducado. La fila sale marcada «Fuera». */
export const clientesDeLaLista = (clientes, buscado = '') => (clientes || []).filter(
    (c) => (String(buscado || '').trim() ? !!c && !c.es_tu_ficha : esDeLaLista(c)));

const masDias = (n) => {
    const d = new Date(`${hoyLocal()}T12:00:00`);
    d.setDate(d.getDate() + n);
    return d.toLocaleDateString('en-CA');
};

/** LA SEMANA DE RUTINA de un cliente de la lista, `{ n, largo }` o null. Una sola cuenta para
 *  la columna, el acordeón, el orden y el filtro (21-10): la del bloque que da el servidor
 *  (`semana_reloj`, de `core/semana_vigente.ancla_del_bloque`, la que se para en la del mensual
 *  mientras no lo manda) y, si no la hay, la de los lunes desde que arrancó la rutina, topada
 *  en el largo del bloque. */
export const semanaDeRutinaDe = (c) => {
    if (c?.semana_reloj != null) return { n: c.semana_reloj, largo: c.largo_reloj || null };
    if (c?.semana_rutina == null) return null;
    const largo = c.rutina_largo || null;
    return { n: largo ? Math.min(c.semana_rutina, largo) : c.semana_rutina, largo };
};

// EN QUÉ PUNTO ESTÁ CADA UNO (reunión del 25-09: «¿quién acaba la semana 12?», «¿a quién le
// toca rutina nueva?», «¿quién renueva?»). Cada opción se responde con lo que ya trae la fila.
export const MOMENTOS = [
    ['todos', 'En cualquier punto', () => true],
    ['ultima_plan', 'Última semana del plan',
        (c) => !!c.cycle_total_weeks && c.week >= c.cycle_total_weeks],
    ['ultima_rutina', 'Última semana de rutina',
        (c) => { const s = semanaDeRutinaDe(c); return !!s?.largo && s.n >= s.largo; }],
    ['renueva_15', 'Renuevan en 15 días',
        (c) => !!c.renueva_el && c.renueva_el >= hoyLocal() && c.renueva_el <= masDias(15)],
    ['sin_rutina', 'Sin rutina', (c) => !!c.id && c.semana_rutina == null],
];

export const enElMomento = (c, momento) => (MOMENTOS.find(([v]) => v === momento) || MOMENTOS[0])[2](c);

// Los filtros y su valor por defecto.
// `sentido` es la flecha del título de la tabla por el que se ordena (21-10): `asc` o `desc`.
// `vista`: la pestaña de la página, Clientes o Gestión de suscripciones (21-10).
export const VISTAS_DE_CLIENTES = ['clientes', 'suscripciones'];
export const FILTROS_DE_CLIENTES = { q: '', plan: 'all', momento: 'todos', orden: 'mensual', sentido: 'asc', vista: 'clientes' };

export const filtrosDeClientesAlEntrar = (search, ordenes) => leerFiltros(search, FILTROS_DE_CLIENTES, {
    momento: MOMENTOS.map(([clave]) => clave),
    sentido: ['asc', 'desc'],
    vista: VISTAS_DE_CLIENTES,
    ...(ordenes ? { orden: ordenes } : {}),
});
